const routes = [
  {
    path: "/manutencao-ocorrencias-administrativas",
    name: "manutencao-ocorrencias-administrativas",
    meta: {
      allowedPermissions: ["ocorrencias_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoOcorrenciasAdministrativas/ManutencaoOcorrenciasAdministrativasHome.vue"
      ),
  },
  {
    path: "/manutencao-ocorrencias-administrativas/novo",
    name: "manutencao-ocorrencias-administrativas-novo",
    meta: {
      allowedPermissions: ["ocorrencias_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoOcorrenciasAdministrativas/ManutencaoOcorrenciasAdministrativasCad.vue"
      ),
  },
  {
    path: "/manutencao-ocorrencias-administrativas/editar/:id",
    name: "manutencao-ocorrencias-administrativas-editar",
    meta: {
      allowedPermissions: ["ocorrencias_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoOcorrenciasAdministrativas/ManutencaoOcorrenciasAdministrativasEdit.vue"
      ),
  },
];

export default routes;
